export const hasThumbnailContainer = (container) => {
  return container.querySelector('.op-thumbnail-container');
};

const createThumbnailContainer = () => {
  const outer = document.createElement('div');
  outer.className = 'op-thumbnail-container';

  const inner = document.createElement('div');
  inner.className = 'op-thumbnail-wrapper';

  const img = document.createElement('img');

  inner.appendChild(img);
  outer.appendChild(inner);

  return outer;
};

export const insertThumbnailContainer = (container) => {
  const target = container.querySelector('.op-helpers-container');

  if (target) {
    const thumbnailContainer = createThumbnailContainer();

    target.appendChild(thumbnailContainer);

    return thumbnailContainer;
  }
};
